export const tagRoutes = {
	tags: (query?: string) => `/tags/${query ? `?${query}` : ''}`,
	tag: (id: string) => `/tags/${id}/`,
	tagHistory: (id: string) => `/tags/${id}/history/`
} as const
